module.exports = __webpack_public_path__ + "static/media/formation-icon-grey.ed12bd87.svg";